import type { TranslationTable } from "@repo/shared/types";

// All 17 locales are kept (QL-17 plan).
export const T: TranslationTable<{ notAllowed: string; unavailable: string }> = {
  en_GB: {
    notAllowed:
      "Single sign-on is not available: the identity provider configuration is not allowed. Contact your administrator.",
    unavailable: "Single sign-on is temporarily unavailable. Try again later.",
  },
  fr_FR: {
    notAllowed:
      "L'authentification unique n'est pas disponible : la configuration du fournisseur d'identité n'est pas autorisée. Contactez votre administrateur.",
    unavailable: "L'authentification unique est temporairement indisponible. Réessayez plus tard.",
  },
  es_ES: {
    notAllowed:
      "El inicio de sesión único no está disponible: la configuración del proveedor de identidad no está permitida. Ponte en contacto con tu administrador.",
    unavailable:
      "El inicio de sesión único no está disponible temporalmente. Inténtalo de nuevo más tarde.",
  },
  pt_BR: {
    notAllowed:
      "O login único não está disponível: a configuração do provedor de identidade não é permitida. Entre em contato com o administrador.",
    unavailable: "O login único está temporariamente indisponível. Tente novamente mais tarde.",
  },
  de_DE: {
    notAllowed:
      "Single Sign-on ist nicht verfügbar: Die Konfiguration des Identitätsanbieters ist nicht zulässig. Wenden Sie sich an Ihren Administrator.",
    unavailable:
      "Single Sign-on ist vorübergehend nicht verfügbar. Versuchen Sie es später erneut.",
  },
  it_IT: {
    notAllowed:
      "Il single sign-on non è disponibile: la configurazione del provider di identità non è consentita. Contatta il tuo amministratore.",
    unavailable: "Il single sign-on è temporaneamente non disponibile. Riprova più tardi.",
  },
  ar: {
    notAllowed:
      "تسجيل الدخول الموحد غير متاح: إعدادات موفر الهوية غير مسموح بها. تواصل مع المسؤول.",
    unavailable: "تسجيل الدخول الموحد غير متاح مؤقتًا. حاول مرة أخرى لاحقًا.",
  },
  ja_JP: {
    notAllowed:
      "シングルサインオンは利用できません。IDプロバイダーの設定が許可されていません。管理者に連絡してください。",
    unavailable:
      "シングルサインオンは一時的に利用できません。しばらくしてからもう一度お試しください。",
  },
  hi_IN: {
    notAllowed:
      "सिंगल साइन-ऑन उपलब्ध नहीं है: आइडेंटिटी प्रोवाइडर का कॉन्फ़िगरेशन अनुमत नहीं है। अपने एडमिनिस्ट्रेटर से संपर्क करें।",
    unavailable: "सिंगल साइन-ऑन अस्थायी रूप से उपलब्ध नहीं है। कृपया बाद में पुनः प्रयास करें।",
  },
  zh_CN: {
    notAllowed: "单点登录不可用：身份提供商的配置不被允许。请联系管理员。",
    unavailable: "单点登录暂时不可用。请稍后再试。",
  },
  zh_TW: {
    notAllowed: "單一登入無法使用：身分提供者的設定不被允許。請聯絡管理員。",
    unavailable: "單一登入暫時無法使用。請稍後再試。",
  },
  nl_NL: {
    notAllowed:
      "Single sign-on is niet beschikbaar: de configuratie van de identiteitsprovider is niet toegestaan. Neem contact op met je beheerder.",
    unavailable: "Single sign-on is tijdelijk niet beschikbaar. Probeer het later opnieuw.",
  },
  nb_NO: {
    notAllowed:
      "Enkel innlogging er ikke tilgjengelig: konfigurasjonen av identitetsleverandøren er ikke tillatt. Kontakt administratoren din.",
    unavailable: "Enkel innlogging er midlertidig utilgjengelig. Prøv igjen senere.",
  },
  sv_SE: {
    notAllowed:
      "Enkel inloggning är inte tillgänglig: identitetsleverantörens konfiguration är inte tillåten. Kontakta din administratör.",
    unavailable: "Enkel inloggning är tillfälligt otillgänglig. Försök igen senare.",
  },
  fi_FI: {
    notAllowed:
      "Kertakirjautuminen ei ole käytettävissä: identiteetintarjoajan määritys ei ole sallittu. Ota yhteyttä ylläpitäjään.",
    unavailable: "Kertakirjautuminen ei ole tilapäisesti käytettävissä. Yritä myöhemmin uudelleen.",
  },
  da_DK: {
    notAllowed:
      "Single sign-on er ikke tilgængeligt: identitetsudbyderens konfiguration er ikke tilladt. Kontakt din administrator.",
    unavailable: "Single sign-on er midlertidigt utilgængeligt. Prøv igen senere.",
  },
  is_IS: {
    notAllowed:
      "Innskráning með einu innskráningarkerfi er ekki í boði: stillingar auðkennisveitunnar eru ekki leyfðar. Hafðu samband við kerfisstjóra.",
    unavailable:
      "Innskráning með einu innskráningarkerfi er tímabundið ekki í boði. Reyndu aftur síðar.",
  },
};
